var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5832 4.95325C21.7508 4.83215 22 4.94543 22 5.13684V13.1251C22 14.1603 21.0762 15.0001 19.9375 15.0001H2.0625C0.923828 15.0001 0 14.1603 0 13.1251V5.14075C0 4.94543 0.244922 4.83606 0.416797 4.95715C1.3793 5.63684 2.65547 6.50012 7.03828 9.39465C7.94492 9.99622 9.47461 11.2618 11 11.254C12.534 11.2657 14.0937 9.97278 14.966 9.39465C19.3488 6.50012 20.6207 5.63293 21.5832 4.95325ZM11 10.0001C11.9969 10.0157 13.432 8.8595 14.1539 8.38293C19.8559 4.62122 20.2898 4.29309 21.6047 3.35559C21.8539 3.17981 22 2.90637 22 2.61731V1.87512C22 0.839966 21.0762 0.00012207 19.9375 0.00012207H2.0625C0.923828 0.00012207 0 0.839966 0 1.87512V2.61731C0 2.90637 0.146094 3.1759 0.395312 3.35559C1.71016 4.28918 2.14414 4.62122 7.84609 8.38293C8.56797 8.8595 10.0031 10.0157 11 10.0001Z",
    fill: "#808282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.5c336c0b0fb94752c52f394a035be4c3.svg";
export { ForwardRef as ReactComponent };